import { Values } from '@utils-global/type-values';

export const ENUM_CLAIM_STATUS = {
  NEW: 'New',
  PENDING_INVOICE: 'Pending Invoice',
  RXP_REJECTED: 'RXP Rejected (R)',
  RXP_REJECTED_NON_ELIGIBLE: 'RXP Rejected (NR)',
  CUSTOMER_RESUBMISSION: 'Customer Resubmission',
  RXP_UNDER_REVIEW: 'RxP Under Review',
  RXP_APPROVED: 'Approved',
  RXP_APPROVED_W_OVERRIDES: 'RXP Approved w/override',
  RXP_RESUBMISSION_REJECTED: 'RxP Resubmission Rejection (F)',
  CLOSED: 'Closed',
  MFG_APPROVED: 'MFG Approved',
  MFG_REJECTED: 'MFG Rejected',
  MFG_RESUBMISSION_REVIEW: 'MFG Resubmission Review',
  MFG_RESUBMISSION_APPROVED: 'MFG Resubmission Approved',
  MFG_RESUBMISSION_REJECTED: 'MFG Resubmission Rejected',

  PENDING_MFG_APPROVAL: 'Pending MFG Approval', // clarify if it is the same RXP_APPROVED
  REJECTED: 'Rejected',
  RESUBMIT_TO_RXP: 'Re-submit to RXP',
  RESUBMISSIONS: 'Resubmissions',

  INVOICED: 'Invoiced',
  INVOICE_PAID: 'Invoice Paid',
  INVOICE_REVERSED: 'Invoice Reversed',
  INVOICE_MFG_PAID: 'MFG Paid',
  INVOICE_MFG_PAYMENT_CONFIRMED: 'MFG Payment Confirmed',
  INVOICE_DISBURSED: 'Disbursed',

  SUMMARY: 'Summary',

  // 340B Audit
  AUDIT_340B: '340B Host Review',
  AUDIT_NOT_340B: 'Not 340B Host Review',
  AUDIT_NOT_EVALUATED: 'Not Evaluated Host Review',
  AUDIT_340B_COMPLETE: 'Audit 340B Complete',
  AUDIT_CLIENT_REVIEW: 'Audit Client Review',
  AUDIT_340B_CLIENT: '340B Client Review',
  AUDIT_NOT_340B_CLIENT: 'Not 340B Client Review',
  AUDIT_NOT_EVALUATED_CLIENT: 'Not Evaluated Client Review',
  AUDIT_EXTERNAL_REVIEW: 'Audit External Review',
  AUDIT_DASHBOARD: 'Audit Dashboard'
} as const;

export enum ClaimStatusOptionValue {
  ACCEPTED = 'A',
  REJECTED = 'R',
  SUBMIT_VALUE_ALT = 'S'
}

export enum ClaimStatusCategory {
  HOST_APPROVED = 1,
  HOST_REJECTED_NR = 2,
  HOST_REJECTED = 3,
  HOST_CUSTOMER_RESUBMISSION = 4,
  MFG_NEW = 5,
  MFG_APPROVED = 6,
  MFG_REJECTED = 7,
  MFG_RESUBMISSION = 8,
  HOST_MFG_APPROVED = 9,
  HOST_MFG_REJECTED = 10,
  HOST_MFG_APPROVED_2 = 11,
  HOST_MFG_REJECTED_2 = 12,
  HOST_CUSTOMER_RESUBMISSION_2 = 13,
  CUSTOMER_RESUBMISSION_REQUESTED = 14,
  HOST_REJECTED_NR_VIEW = 15,
  HOST_REJECTED_CLIENT_RESUBMISSION = 16,
  CUSTOMER_HOST_REJECTED = 20,
  CUSTOMER_MFG_REJECTED = 21,
  CUSTOMER_RESUBMISSION_2 = 41,
  CANCELLED_BY_CLIENT = 100,
  READY_FOR_INVOICING = 101,
  INVOICED = 102,
  INVOICE_PAID = 103,
  INVOICE_REVERSED = 104,
  CLOSED_NOT_USED = 105,
  INVOICE_MFG_PAID = 502,
  INVOICE_MFG_PAYMENT_CONFIRMED = 503,
  INVOICE_DISBURSED = 504,
  CLOSED = 999
}

export enum ClaimStatusOption {
  RXP_REJECTED = 1,
  RXP_APPROVED = 2,
  RXP_APPROVED_OVERRIDE = 3,
  RXP_APPROVAL_REVIEW = 4,
  CUSTOMER_SUBMISSION_REQUESTED = 5,
  SUBMIT_TO_CUSTOMER = 6,
  RXP_RESUBMISSION_REJECTION = 7,
  MFG_RESUBMISSION_APPROVAL_REVIEW = 8,
  RXP_CLOSED = 9,
  INVOICE = 10,
  MFG_PAYMENT_CONFIRMED = 11,
  DISBURSED = 12,
  MFG_CLOSED = 13,
  MFG_APPROVED = 14,
  MFG_APPROVED_ADJUSTMENT = 15,
  MFG_REJECTED = 16,
  MFG_RESUBMISSION_APPROVED = 17,
  MFG_RESUBMISSION_REJECTED = 18,
  MFG_PAID = 19,
  RESUBMISSION_REQUESTED = 20,
  CUSTOMER_CLOSED = 21,
  SEND_TO_PBM = 22,
  MFG_APPROVAL_REVIEW = 23,
  RXP_REJECTED_NON_ELIGIBLE = 24,
  MFG_RESUBMISSION_REJECTED_REVIEW = 25,
  RXP_RESUBMISSION_APPROVAL_REVIEW = 26,
  AUDIT_MOVE_TO_340B = 27,
  AUDIT_MOVE_TO_NOT_340B = 28,
  AUDIT_COMPLETE = 29,
  AUDIT_MFG_APPROVAL_REVIEW = 30,
  RXP_REJECTED_NON_ELIGIBLE_FINALIZE = 31,
  AUDIT_DISPUTE = 32,
  AUDIT_NOT_DISPUTE = 33,
  AUDIT_RESOLVED = 34,
  AUDIT_REJECTED = 35,
  AUDIT_WITHDRAWN = 36,
  INVOICE_PAID = 37,
  INVOICE_REVERSED = 38,
  INVOICE_MFG_PAID = 39,
  INVOICE_MFG_PAYMENT_CONFIRMED = 40,
  INVOICE_DISBURSED = 41
}

export enum Audit340BClaimQueue {
  HOST = 'host',
  CUSTOMER = 'customer',
  EXTERNAL = 'external'
}

export enum Audit340BClaimStatus {
  IS_340B = '340b',
  NOT_340B = 'not_340b',
  NOT_EVALUATED = 'not_evaluated',
  DISPUTED = 'dispute',
  NOT_DISPUTED = 'not_dispute',
  APPROVED = 'approved',
  REJECTED = 'rejected',
  PAID = 'paid',
  WITHDRAWN = 'withdrawn'
}

export enum Audit340BClaimStatusNum {
  IS_340B = 1,
  NOT_340B = 2,
  NOT_EVALUATED = 4,
  DISPUTED = 17,
  NOT_DISPUTED = 18,
  APPROVED = 20,
  REJECTED = 34,
  PAID = 68,
  WITHDRAWN = 69
}

export const REBATE_STATUS_LABEL_MAP = new Map<number, string>([
  [ClaimStatusCategory.HOST_APPROVED, 'Approved'],
  [ClaimStatusCategory.HOST_REJECTED_NR, 'Rejected Non Rebate'],
  [ClaimStatusCategory.HOST_REJECTED, 'Rejected'],
  [ClaimStatusCategory.HOST_CUSTOMER_RESUBMISSION, 'Customer Resubmission'],
  [ClaimStatusCategory.MFG_NEW, 'New'],
  [ClaimStatusCategory.MFG_APPROVED, 'MFG Approved'],
  [ClaimStatusCategory.MFG_REJECTED, 'MFG Rejected'],
  [ClaimStatusCategory.MFG_RESUBMISSION, 'MFG Resubmission'],
  [ClaimStatusCategory.HOST_MFG_APPROVED, 'Host MFG Approve'],
  [ClaimStatusCategory.HOST_MFG_REJECTED, 'Host MFG Rejected'],
  [ClaimStatusCategory.HOST_MFG_APPROVED_2, 'MFG Resubmission Approved'],
  [ClaimStatusCategory.HOST_MFG_REJECTED_2, 'MFG Resubmission Rejected'],
  [
    ClaimStatusCategory.HOST_CUSTOMER_RESUBMISSION_2,
    'RxP Resubmission Rejected'
  ],
  [
    ClaimStatusCategory.CUSTOMER_RESUBMISSION_REQUESTED,
    'Customer Resubmission Requested'
  ],
  [ClaimStatusCategory.HOST_REJECTED_NR_VIEW, 'RxP Rejected Non Rebate'],
  [
    ClaimStatusCategory.HOST_REJECTED_CLIENT_RESUBMISSION,
    'Host Reject Client Resubmission'
  ],
  [ClaimStatusCategory.CUSTOMER_HOST_REJECTED, 'Custoer RxP Rejected'],
  [ClaimStatusCategory.CUSTOMER_MFG_REJECTED, 'Customer MFG Rejected'],
  [ClaimStatusCategory.CUSTOMER_RESUBMISSION_2, 'Customer Second Resubmission'],
  [ClaimStatusCategory.CANCELLED_BY_CLIENT, 'Cancelled'],
  [ClaimStatusCategory.READY_FOR_INVOICING, 'Ready for Invoicing'],
  [ClaimStatusCategory.INVOICED, 'Invoiced'],
  [ClaimStatusCategory.INVOICE_PAID, 'Invoice Approved'],
  [ClaimStatusCategory.INVOICE_REVERSED, 'Invoice Rejected'],
  [ClaimStatusCategory.CLOSED_NOT_USED, 'Closed'],
  [ClaimStatusCategory.INVOICE_MFG_PAID, 'Manufacturer Paid'],
  [
    ClaimStatusCategory.INVOICE_MFG_PAYMENT_CONFIRMED,
    'Manufacturer Payment Confirmed'
  ],
  [ClaimStatusCategory.INVOICE_DISBURSED, 'Disbursed'],
  [ClaimStatusCategory.CLOSED, 'Closed']
]);

export const AUDIT_340B_STATUS_LABEL_MAP = new Map<number, string>([
  [Audit340BClaimStatusNum.IS_340B, '340B'],
  [Audit340BClaimStatusNum.NOT_340B, 'Not 340B'],
  [Audit340BClaimStatusNum.NOT_EVALUATED, 'Not Evaluated']
]);

export const CLAIM_STATUS_OPTION_VALUES = new Map<
  ClaimStatusOption,
  ClaimStatusOptionValue | Audit340BClaimStatus
>([
  [ClaimStatusOption.RXP_REJECTED, ClaimStatusOptionValue.REJECTED],
  [ClaimStatusOption.RXP_APPROVED, ClaimStatusOptionValue.ACCEPTED],
  [ClaimStatusOption.RXP_APPROVED_OVERRIDE, ClaimStatusOptionValue.ACCEPTED],
  [ClaimStatusOption.RXP_APPROVAL_REVIEW, ClaimStatusOptionValue.ACCEPTED],
  [
    ClaimStatusOption.CUSTOMER_SUBMISSION_REQUESTED,
    ClaimStatusOptionValue.REJECTED
  ],
  [ClaimStatusOption.SUBMIT_TO_CUSTOMER, ClaimStatusOptionValue.REJECTED],
  [
    ClaimStatusOption.RXP_RESUBMISSION_REJECTION,
    ClaimStatusOptionValue.REJECTED
  ],
  [
    ClaimStatusOption.MFG_RESUBMISSION_APPROVAL_REVIEW,
    ClaimStatusOptionValue.SUBMIT_VALUE_ALT
  ],
  [ClaimStatusOption.RXP_CLOSED, ClaimStatusOptionValue.REJECTED],
  [ClaimStatusOption.INVOICE, ClaimStatusOptionValue.ACCEPTED],
  [ClaimStatusOption.MFG_PAYMENT_CONFIRMED, ClaimStatusOptionValue.ACCEPTED],
  [ClaimStatusOption.DISBURSED, ClaimStatusOptionValue.ACCEPTED],
  [ClaimStatusOption.MFG_CLOSED, ClaimStatusOptionValue.REJECTED],
  [ClaimStatusOption.MFG_APPROVED, ClaimStatusOptionValue.ACCEPTED],
  [ClaimStatusOption.MFG_APPROVED_ADJUSTMENT, ClaimStatusOptionValue.ACCEPTED],
  [ClaimStatusOption.MFG_REJECTED, ClaimStatusOptionValue.REJECTED],
  [
    ClaimStatusOption.MFG_RESUBMISSION_APPROVED,
    ClaimStatusOptionValue.ACCEPTED
  ],
  [
    ClaimStatusOption.MFG_RESUBMISSION_REJECTED,
    ClaimStatusOptionValue.REJECTED
  ],
  [ClaimStatusOption.MFG_PAID, ClaimStatusOptionValue.ACCEPTED],
  [ClaimStatusOption.RESUBMISSION_REQUESTED, ClaimStatusOptionValue.ACCEPTED],
  [ClaimStatusOption.CUSTOMER_CLOSED, ClaimStatusOptionValue.REJECTED],
  [ClaimStatusOption.SEND_TO_PBM, ClaimStatusOptionValue.ACCEPTED],
  [ClaimStatusOption.MFG_APPROVAL_REVIEW, ClaimStatusOptionValue.ACCEPTED],
  [
    ClaimStatusOption.RXP_REJECTED_NON_ELIGIBLE,
    ClaimStatusOptionValue.REJECTED
  ],
  [
    ClaimStatusOption.MFG_RESUBMISSION_REJECTED_REVIEW,
    ClaimStatusOptionValue.ACCEPTED
  ],
  [
    ClaimStatusOption.RXP_RESUBMISSION_APPROVAL_REVIEW,
    ClaimStatusOptionValue.ACCEPTED
  ],
  [ClaimStatusOption.AUDIT_MOVE_TO_340B, Audit340BClaimStatus.IS_340B],
  [ClaimStatusOption.AUDIT_MOVE_TO_NOT_340B, Audit340BClaimStatus.NOT_340B],
  [ClaimStatusOption.AUDIT_COMPLETE, ClaimStatusOptionValue.ACCEPTED],
  [ClaimStatusOption.AUDIT_DISPUTE, Audit340BClaimStatus.DISPUTED],
  [ClaimStatusOption.AUDIT_NOT_DISPUTE, Audit340BClaimStatus.NOT_DISPUTED],
  [ClaimStatusOption.AUDIT_RESOLVED, Audit340BClaimStatus.APPROVED],
  [ClaimStatusOption.AUDIT_REJECTED, Audit340BClaimStatus.REJECTED],
  [ClaimStatusOption.AUDIT_WITHDRAWN, Audit340BClaimStatus.WITHDRAWN],
  [
    ClaimStatusOption.AUDIT_MFG_APPROVAL_REVIEW,
    ClaimStatusOptionValue.SUBMIT_VALUE_ALT
  ],
  [
    ClaimStatusOption.RXP_REJECTED_NON_ELIGIBLE_FINALIZE,
    ClaimStatusOptionValue.ACCEPTED
  ],
  [ClaimStatusOption.INVOICE_PAID, ClaimStatusOptionValue.ACCEPTED],
  [ClaimStatusOption.INVOICE_REVERSED, ClaimStatusOptionValue.REJECTED],
  [ClaimStatusOption.INVOICE_MFG_PAID, ClaimStatusOptionValue.ACCEPTED],
  [
    ClaimStatusOption.INVOICE_MFG_PAYMENT_CONFIRMED,
    ClaimStatusOptionValue.ACCEPTED
  ],
  [ClaimStatusOption.INVOICE_DISBURSED, ClaimStatusOptionValue.ACCEPTED]
]);

export const REBATE_CLAIM_STATUS_CONFIGURATION = new Map<
  Values<typeof ENUM_CLAIM_STATUS>,
  { category: ClaimStatusCategory }
>([
  [
    ENUM_CLAIM_STATUS.RXP_APPROVED,
    { category: ClaimStatusCategory.HOST_APPROVED }
  ],
  [
    ENUM_CLAIM_STATUS.RXP_REJECTED_NON_ELIGIBLE,
    { category: ClaimStatusCategory.HOST_REJECTED_NR }
  ],
  [
    ENUM_CLAIM_STATUS.RXP_REJECTED,
    { category: ClaimStatusCategory.HOST_REJECTED }
  ],
  [
    ENUM_CLAIM_STATUS.CUSTOMER_RESUBMISSION,
    { category: ClaimStatusCategory.HOST_CUSTOMER_RESUBMISSION }
  ],
  [
    ENUM_CLAIM_STATUS.RXP_RESUBMISSION_REJECTED,
    { category: ClaimStatusCategory.HOST_CUSTOMER_RESUBMISSION_2 }
  ],
  [ENUM_CLAIM_STATUS.NEW, { category: ClaimStatusCategory.MFG_NEW }],
  [
    ENUM_CLAIM_STATUS.MFG_APPROVED,
    { category: ClaimStatusCategory.HOST_MFG_APPROVED }
  ],
  [
    ENUM_CLAIM_STATUS.MFG_REJECTED,
    { category: ClaimStatusCategory.HOST_MFG_REJECTED }
  ],
  [
    ENUM_CLAIM_STATUS.MFG_RESUBMISSION_REVIEW,
    { category: ClaimStatusCategory.MFG_RESUBMISSION }
  ],
  [
    ENUM_CLAIM_STATUS.MFG_RESUBMISSION_APPROVED,
    { category: ClaimStatusCategory.HOST_MFG_APPROVED_2 }
  ],
  [
    ENUM_CLAIM_STATUS.MFG_RESUBMISSION_REJECTED,
    { category: ClaimStatusCategory.HOST_MFG_REJECTED_2 }
  ],
  [
    ENUM_CLAIM_STATUS.RESUBMISSIONS,
    { category: ClaimStatusCategory.HOST_CUSTOMER_RESUBMISSION_2 }
  ],
  [ENUM_CLAIM_STATUS.INVOICED, { category: ClaimStatusCategory.INVOICED }],
  [
    ENUM_CLAIM_STATUS.INVOICE_PAID,
    { category: ClaimStatusCategory.INVOICE_PAID }
  ],
  [
    ENUM_CLAIM_STATUS.INVOICE_MFG_PAID,
    { category: ClaimStatusCategory.INVOICE_MFG_PAID }
  ],
  [
    ENUM_CLAIM_STATUS.INVOICE_MFG_PAYMENT_CONFIRMED,
    { category: ClaimStatusCategory.INVOICE_MFG_PAYMENT_CONFIRMED }
  ]
]);

export const AUDIT_340B_CLAIM_STATUS_CONFIGURATION = new Map<
  Values<typeof ENUM_CLAIM_STATUS>,
  {
    category?: Audit340BClaimStatus;
    statusIds?: Audit340BClaimStatusNum[];
    queue: Audit340BClaimQueue;
  }
>([
  [
    ENUM_CLAIM_STATUS.AUDIT_340B,
    { category: Audit340BClaimStatus.IS_340B, queue: Audit340BClaimQueue.HOST }
  ],
  [
    ENUM_CLAIM_STATUS.AUDIT_NOT_340B,
    { category: Audit340BClaimStatus.NOT_340B, queue: Audit340BClaimQueue.HOST }
  ],
  [
    ENUM_CLAIM_STATUS.AUDIT_NOT_EVALUATED,
    {
      category: Audit340BClaimStatus.NOT_EVALUATED,
      queue: Audit340BClaimQueue.HOST
    }
  ],
  [
    ENUM_CLAIM_STATUS.AUDIT_CLIENT_REVIEW,
    {
      queue: Audit340BClaimQueue.CUSTOMER,
      statusIds: [
        Audit340BClaimStatusNum.IS_340B,
        Audit340BClaimStatusNum.NOT_340B,
        Audit340BClaimStatusNum.NOT_EVALUATED
      ]
    }
  ],
  [
    ENUM_CLAIM_STATUS.AUDIT_340B_CLIENT,
    {
      category: Audit340BClaimStatus.IS_340B,
      queue: Audit340BClaimQueue.CUSTOMER
    }
  ],
  [
    ENUM_CLAIM_STATUS.AUDIT_NOT_340B_CLIENT,
    {
      category: Audit340BClaimStatus.NOT_340B,
      queue: Audit340BClaimQueue.CUSTOMER
    }
  ],
  [
    ENUM_CLAIM_STATUS.AUDIT_NOT_EVALUATED_CLIENT,
    {
      category: Audit340BClaimStatus.NOT_EVALUATED,
      queue: Audit340BClaimQueue.CUSTOMER
    }
  ],
  [
    ENUM_CLAIM_STATUS.AUDIT_EXTERNAL_REVIEW,
    {
      queue: Audit340BClaimQueue.EXTERNAL,
      statusIds: [Audit340BClaimStatusNum.DISPUTED]
    }
  ]
]);
